export const GAME_CREATED_NEW_START = 'game.CREATED_NEW_START';
export const GAME_CREATED_NEW = 'game.CREATED_NEW';
export const GAME_CREATED_NEW_ENDED = 'game.CREATED_NEW_ENDED';
export const GAME_LOADED_START = 'game.LOADED_START';
export const GAME_LOADED = 'game.LOADED';
export const GAME_LOADED_ENDED = 'game.LOADED_ENDED';
export const GAME_RESET = 'game.RESET';
export const GAME_UPDATE_CASH = 'game.UPDATE_CASH';
export const GAME_UPDATE_STARTED_TURN_WITH_AUTO_BOOKKEEPER 
	= 'game.UPDATE_HAS_STARTED_TURN_WITH_AUTO_BOOKKEEPER';
export const GAME_OVER = 'game.OVER';
export const GAME_COMPLETED = 'game.COMPLETED';
